module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("THROUGH WATERS DEEP")]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_vm._v("Kimberly")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("But now, this is what the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" says—he who created you, Jacob, he who formed you, Israel: “Do not fear, for I have redeemed you; I have summoned you by name; you are mine. When you pass through the waters, I will be with you; and when you pass through the rivers, they will not sweep over you. When you walk through the fire, you will not be burned; the flames will not set you ablaze.”")]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_vm._v("ISAIAH 43:1–2")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('span', {
    staticClass: "co"
  }, [_vm._v("A")])]), _vm._v("lmost immediately after being discharged from the NICU, Abbey began to receive early intervention services. Suddenly complete strangers were in my home, touching my baby and telling me how to care for her, five days a week. These were in addition to all the specialists and physicians who were now on our speed dial. It was a dramatically different routine than I’d expected. Into the calendar went many appointments: OT, PT, speech therapy, developmental therapist, doctors, and clinics. Out went family time, friend time, me time, and church time. By the time Abbey reached the age of three, I thought there was a good chance I would never have the gift of a friend, the blessing of a healthy marriage, or the joy of other children.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("I couldn’t have been more wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("In those trials and early years, I learned so much about the character of God, my sinful nature, and the hope I have in him. When our routines and our child’s disabilities threaten us, we have to hold on to the promises in Scripture passages such as Isaiah 43:1–2. We will pass through the waters; the waters are unavoidable, but we are never alone. God promises that with him by our side, they will not destroy us.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Sometimes these waters show us the depth of our own sinful nature. As I found my marriage struggling with our new normal, I turned to other friendships for comfort and assurance. Ryan turned to his new job and spent many hours beyond what was necessary away from home in order to gain a sense of control over our out-of-control life. A deep wedge was forming between us. When family and circumstances opened our eyes to our situation, we knew that God could use this to refine us. We turned to Isaiah 48:10–11 as a verse for our marriage: “See, I have refined you, though not as silver; I have tested you in the furnace of affliction. For my own sake, for my own sake, I do this. How can I let myself be defamed? I will not yield my glory to another.”")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("We need to know we’re not alone. We need to allow what we are going through to refine us, and yet it’s also exciting to learn new things about our relationship with the living God, for his glory. Jared Buckley, whose daughter Fayth has Down syndrome, explains on his blog:")]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("We have learned that through the power of Jesus Christ, there is nothing we cannot handle. We have given our worries, concerns, fears, anxieties, and struggles over to Jesus and have come out victorious (Romans 8:34–39). We live our life encouraged, hopeful, peaceful, and joyful because our life is not our own and we live by faith in Jesus Christ (Galatians 2:20). We are now co-heirs to Christ’s throne and live in His kingdom and presence everyday (Romans 8:17).")]), _vm._v(" "), _c('p', {
    staticClass: "extracti"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("There is nothing that can take away our victory through "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Jesus. This victory has given us the greatest peace in our parenting a special needs child. When all things happen, we come back to the fact that Jesus still reigns and He has and will always love us unconditionally. [The] result is encouragement."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#fn8",
      "id": "rfn8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("Sometimes the new normal is excruciatingly difficult, yes, but it can also be amazingly beautiful. There will be days when it feels like it’s all you can do to keep your head above water. But not only is God with you, he also will lead you through until you’re safe on the other side.")]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Dear Jesus, I praise you that you promise I don’t have to do this alone. Use this new normal to show me the depth of your love, to refine my character, and to teach me about yours. In Jesus’s name, amen.")])])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGGING")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEPER")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("1."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("What areas of your new normal are difficult to manage?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("2."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("In what ways can you see God refining you through this process?")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("3."), _c('span', {
    staticClass: "space5"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("How has your refining process shown you new discoveries about God’s character?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83c45efa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter04.vue
// module id = 93
// module chunks = 0